const userResponsibilities = [
  { name: "Employability Officer", value: "EMPLOYABILITY_OFFICER" },
  { name: "Academy Officer", value: "ACADEMY_OFFICER" },
  { name: "Communication Responsible", value: "COMMUNICATION_RESPONSIBLE" },
  { name: "Talent Acquisition Officer", value: "TALENT_ACQUISITION_OFFICER" },
];
export default userResponsibilities;
